import { useTranslation } from 'react-i18next'

import { Announced } from '@dhl/illustrations'
import { Box, Grid, H6 } from '@dhl-ui/components'

export const LabelRequestSkeleton = () => {
  const { t } = useTranslation()
  return (
    <Grid data-testid="label-request-skeleton">
      <Box
        pt={1}
        pb={2}
        display="flex"
        justifyContent="center"
        alignItems="center"
        sx={{ backgroundColor: 'common.white', marginTop: 3 }}
      >
        <Announced sx={{ width: '255px', height: '169px' }} />
      </Box>
      <Grid>
        <Box
          pt={1}
          pb={10}
          sx={{ backgroundColor: 'common.white' }}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <H6>{t('admin.labelPage.perfectTrackerCodeTipsText')}</H6>
        </Box>
      </Grid>
    </Grid>
  )
}
